import React, { useState, useRef, useEffect } from 'react';
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口
import * as echarts from 'echarts/core';
// import * as allCharts from 'echarts/charts';
import { EChartsOption } from 'echarts';
import { throttle } from '@lhb/func';
import eventLib from 'src/common/document-event/index';
// import { color } from '@/common/enums/color';

interface EchartProp {
  options: EChartsOption | {};
  otherOption?: { // https://echarts.apache.org/zh/api.html#echartsInstance.setOption
    notMerge?: boolean;
    replaceMerge?: string | string[];
    lazyUpdate?: boolean;
  };
  width?: string;
  height?: string;
  // width?: string;
  className?: string;
  // isDestroy?: boolean; // 数据变化是否清空画布-默认为false
  loadedEchartsHandle?: (ins: any) => void
}

const Echart: React.FC<EchartProp> = ({
  options,
  otherOption = {},
  height,
  width,
  className,
  loadedEchartsHandle
}) => {
  // 用来获取渲染后的 DOM
  const chartDomRef = useRef<HTMLDivElement>(null);
  // 存储生成后的 图表实例对象
  const [echartsInstance, setEchartsInstance] = useState<any>(null);


  // 仅第一次挂载时执行，将 DOM 传递给 echarts，通过 echarts.init() 得到真正的图表 JS 对象
  useEffect(() => {
    let chart: any;
    if (chartDomRef?.current) {
      chart = echarts.init(chartDomRef.current);
      setEchartsInstance(chart);
      eventLib.on('NAVCHANGE', () => {
        setTimeout(() => {
          chart.resize();
        }, 200);
      });

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let observer:any;
    if (echartsInstance) { // 获取到实例后，监听窗口变化，自动调整图表大小
      const throttleResize = throttle(echartsInstance.resize, 300);
      // 创建并返回一个ResizeObserver对象。并且把echartsInstance.resize作为监听后回调函数传入
      observer = new ResizeObserver(throttleResize);

      observer.observe(chartDomRef.current);
    }

    // 卸载时取消监听，防止内存泄漏
    return () => {
      echartsInstance && observer.disconnect();
    };
  }, [echartsInstance]);


  useEffect(() => {
    echartsInstance && loadedEchartsHandle && loadedEchartsHandle(echartsInstance);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [echartsInstance]);

  // 监听依赖变化，并根据需要更新图表数据
  useEffect(() => {
    if (echartsInstance && options && Object.keys(options).length) {
      try {
        echartsInstance.setOption(options, otherOption);
      } catch (error) {
        console.log(`echartsInstance`, error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, otherOption]);

  return <div
    ref={chartDomRef}
    className={className}
    style={{
      width: width,
      height
    }} />;
};

export default Echart;
